import React from 'react';
import { Stack, Label, TextField, DefaultButton, IconButton } from '@fluentui/react';

export interface TagRow {
    key: string;
    value: string;
}

interface UpdateTagsSubcategoryPanelProps {
    disabled: boolean
    tags: TagRow[]
    setTags: React.Dispatch<React.SetStateAction<TagRow[]>>
    // キーの採番は親が持つカウンタに委ねる（削除済みキーの再利用を防ぐため）
    nextTagKey: () => string
}

/**
 * サブカテゴリの定義を編集するパネル。
 * 編集内容は親の状態に溜めるだけで、実際の反映は画面下部の「編集を完了して検索へ反映」で行う。
 */
export const UpdateTagsSubcategoryPanel = (props: UpdateTagsSubcategoryPanelProps) => {
    const { disabled, tags, setTags, nextTagKey } = props

    const handleValueChange = (index: number, value: string) => {
        setTags(prev => prev.map((tag, i) => (i === index ? { ...tag, value } : tag)));
    };

    const handleAddTag = () => {
        setTags(prev => [...prev, { key: nextTagKey(), value: '' }]);
    };

    const handleRemoveTag = (index: number) => {
        setTags(prev => prev.filter((_, i) => i !== index));
    };

    return (
        <Stack tokens={{ childrenGap: 10, padding: '20px 0' }}>
            <Stack horizontal tokens={{ childrenGap: 10 }}>
                <Label styles={{ root: { flex: 1, fontWeight: 600 } }}>サブカテゴリ</Label>
                <Stack styles={{ root: { width: 40 } }} />
            </Stack>

            {tags.length === 0 && (
                <Label styles={{ root: { color: '#666' } }}>サブカテゴリが設定されていません</Label>
            )}

            {tags.map((tag, index) => (
                <Stack key={tag.key} horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
                    <TextField
                        value={tag.value}
                        onChange={(_, newValue) => handleValueChange(index, newValue || '')}
                        placeholder="値"
                        styles={{ root: { flex: 1, maxWidth: "600px" } }}
                        autoComplete="off"
                        disabled={disabled}
                    />
                    <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="削除"
                        ariaLabel="削除"
                        onClick={() => handleRemoveTag(index)}
                        disabled={disabled}
                    />
                </Stack>
            ))}

            <DefaultButton
                text="サブカテゴリを追加"
                iconProps={{ iconName: 'Add' }}
                onClick={handleAddTag}
                styles={{ root: { width: 'fit-content', marginTop: 10 } }}
                disabled={disabled}
            />
        </Stack>
    );
};
